import {Injectable, signal} from '@angular/core';
import {format, isAfter, isBefore} from "date-fns";
import {ApiRequestService} from "./api-request.service";
import {toObservable} from "@angular/core/rxjs-interop";
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root',
})
export class StudentEnrollmentService {

    public classScheduleState = signal( 'null' ); // null | none | loading | complete | error
    public classScheduleError = "";

    public myClasses = signal(null);
    public myClasses$ = toObservable(this.myClasses);

    public optIn: boolean = false;

    private classes: any = [];

    constructor(
        private apiService: ApiRequestService
    ) {
    }
    public setOptIn( pref: boolean ) {
        this.optIn = pref;
        if ( !this.optIn ) {
            this.classes = [];
            this.myClasses.set(this.classes);
        }
    }
    public processClasses() {
        if ( !environment.feature_studentEnrollment || !this.optIn ) {
            return;
        }
        this.classes = [];
        this.classScheduleState.set('loading');
        let today = new Date();
        this.apiService.getPersonClasses().subscribe({
            next: (resp:any) => {
                if ( resp.length > 0 ) {
                    resp.forEach( (student:any) => {
                        let c = {
                            courseNumber: student.number,
                            courseCode: student.code,
                            courseName: student.name,
                            courseTerm: student.term,
                            courseCRN: student.crn,
                            courseSchedule: student.meetingTimes,
                            courseLocation: student.location,
                            courseCampus: student.campus,
                            courseStartFormated: "",
                            courseEndedFormatted: "",
                            courseEnded: false,
                            courseStarted: true,
                            gradesProcessed: student.gradesProcessed,
                            instructionalDeliveryMethod: student.instructionalDeliveryMethod.title,
                            instructionalMethods: student.instructionalMethods[0].title
                        };
                        c.courseSchedule.sort((a:any, b:any) => a.startDate.localeCompare(b.startDate));
                        this.classes.push( c );
                    })
                }
                this.classScheduleState.set('complete');
                this.myClasses.set(this.classes);
                // console.log(this.classes);
            }, error: err => {
                this.classScheduleState.set('error');
                this.classScheduleError = err.error;
            }
        })
    }
}
